import { CreateKYCPackFormValues } from ".";


export const createKYCPackFormValuesInitialValue = (): CreateKYCPackFormValues => {
    return {
        recipientEmailAddress: '',
        recipientName: '',
        includeCertificate: false,
        proofOfAddress: false,
        identityDocument: false,
        selfie: false,
    }
}